import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';

import styles from './banner.module.less';

const bannerImageDesktop =
    'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/role-play/roleplay-topics-image-840x600.png';
const bannerImageMobile =
    'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/role-play/roleplay-topics-image-420x300.png';

export const Banner: React.FC = () => {
    const {gettext} = useI18n();

    return (
        <div className={styles['container']}>
            <div className={classNames('ud-container', styles.banner)}>
                <div className={styles['banner-header']}>
                    <h1 className={'ud-heading-serif-xxl'}>{gettext('Role Play')}</h1>
                    <p className={'ud-text'}>
                        {gettext(
                            'Meet your AI-powered conversation coach for practicing business and communication skills. Build your confidence the interactive way.',
                        )}
                    </p>
                </div>

                <div className={styles['banner-image-container']}>
                    <Image
                        alt=""
                        className={styles['banner-image']}
                        src={bannerImageDesktop}
                        srcSet={`${bannerImageMobile} 420w, ${bannerImageDesktop} 840w`}
                        sizes="(max-width: 767px) 420px, 840px"
                        height={300}
                        width={420}
                    />
                </div>
            </div>
        </div>
    );
};
